import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "onClick"]


import { defineComponent, watch, ref, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { LoaderButtonStore } from "../store/loader-button-store";

const __default__ = defineComponent({
  name: "LoaderButton",
  components: {},
  props: {
    cssButton: String,
    isDisabled: Boolean,
  },
  computed: {},
  methods: {
    stop() {
      console.log("loader-button - stop");
    },
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["loaderClick"],
  setup(__props, { expose: __expose, emit }) {


const { lbtnStatus } = storeToRefs(LoaderButtonStore());

let hdTime: null | any;
let isLoad = ref(false);

onUnmounted(() => {
  if (hdTime) {
    clearTimeout(hdTime);
  }
});

watch(lbtnStatus, (newStatus, oldStatus) => {
  if (!newStatus) {
    stop();
  }
});

const onClick = () => {
  if (isLoad.value) {
    return;
  }

  start();
  emit("loaderClick");
};

const start = () => {
  LoaderButtonStore().start();
  hdTime = setTimeout(() => {
    isLoad.value = true;
  }, 1000);
};

const stop = () => {
  if (hdTime) {
    clearTimeout(hdTime);
    hdTime = null;
  }

  isLoad.value = false;
};

__expose({ stop });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["cs-btn", [_ctx.cssButton && !_unref(isLoad) && !_ctx.isDisabled ? _ctx.cssButton : 'cs-btn-disabled']]),
    disabled: _unref(isLoad) || _ctx.isDisabled,
    onClick: _withModifiers(onClick, ["stop"])
  }, [
    _renderSlot(_ctx.$slots, "title")
  ], 10, _hoisted_1))
}
}

})